import React from "react";
import { useSelector } from "react-redux";
import css from "./MenuTitle.module.css";
import { getConfig } from "../../config";

const MenuTitle = () => {
  const customLogo = useSelector((state) => state.builder.adminConfig?.logo);
  const logo = customLogo || getConfig().logo;
  return (
    <section className={css.wrap}>
      <img src={logo} alt="GWT Logo" className={css.logoImage} />
    </section>
  );
};

export { MenuTitle };
